export default "__VITE_ASSET__DxcRWdsI__"